<template>
  <div class="contain">
    <div
        style="
        margin-top: 4rem;
        font-size: 2rem;
        line-height: 2rem;
        font-weight: bold;
        color: #b62d2e;
      "
    >
      忘記密碼 Forgot Password
    </div>
    <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
      <span
          style="
          width: 1rem;
          height: 1rem;
          background: #b62d2e;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
          style="
          width: 1rem;
          height: 1rem;
          background: #de5934;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
          style="
          width: 1rem;
          height: 1rem;
          background: #f1aa55;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
    </div>
    <div class="col-xs-22 col-sm-13" style="text-align: center">
      請輸入您的家長電郵地址，選擇重置家長的密碼還是學生的密碼，我們將會向您發送重置後的密碼<br />
      Please enter your parent’s email address and select whether to reset the parent’s password or the child’s password. <br />We will send the new password to this email.
    </div>
    <div class="security-box">
      <el-form ref="form" :model="form" style="margin-top: 6rem" :rules="formRules">
        <!-- 邮箱输入项 -->
        <el-form-item prop="email">
          <div class="security-title">家長電郵地址 Parent‘s Email</div>
          <el-input v-model="form.email" placeholder="電郵地址 Email"></el-input>
        </el-form-item>

        <!-- 验证码输入项（核心优化） -->
        <el-form-item prop="code">
          <div class="security-title">驗證碼 Verification Code</div>
          <div class="code-row">
            <el-input v-model="form.code" placeholder="郵箱驗證碼 Verification code"></el-input>
            <el-button
                class="code-btn"
                :disabled="codeDisabled"
                @click="getEmailCode"
            >
              {{ codeBtnText }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 重置类型单选框 -->
        <el-form-item prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">重置家長密碼 Reset Parent Password</el-radio>
            <el-radio :label="2">重置學生密碼（使用家長電郵）Reset Student Password</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="display: flex; flex-direction: column; margin-top: 6rem">
        <el-button class="security-button" round @click="onConfirm">確認 Confirm</el-button>
        <el-button class="security-button" round @click="onBackText">返回 Back</el-button>
      </div>
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog/index";
import {forgetPasswordEmail, sendPasswordEmailCode} from "@/api/security";
export default {
  components: { loadingDialog },
  data() {
    return {
      centerDialogVisible: false,
      // 表单数据
      form: {
        email: "",
        code: "",
        type: 1,
      },
      // 验证码倒计时配置
      codeTimer: null,
      codeCount: 60,
      codeDisabled: false,
      codeBtnText: "獲取驗證碼 Get Code",
      // 表单校验规则（分离优化，中英文提示）
      formRules: {
        email: [
          { required: true, message: "請輸入家長電郵地址 Please enter parent's e-mail address", trigger: "blur" },
          { type: "email", message: "電郵格式不正確 Incorrect email format", trigger: "blur" }
        ],
        code: [
          { required: true, message: "請輸入驗證碼 Please enter verification code", trigger: "blur" }
        ],
        type: [
          { required: true, message: "請選擇重置類型 Please select reset type", trigger: "change" }
        ]
      }
    };
  },
  beforeDestroy() {
    // 页面销毁清除定时器，防止内存泄漏
    if (this.codeTimer) clearInterval(this.codeTimer);
  },
  methods: {
    // 获取邮箱验证码
    async getEmailCode() {
      // 先校验邮箱，不通过直接拦截
      await this.$refs.form.validateField("email");
      const emailErr = this.$refs.form.fields.find(item => item.prop === "email" && item.validateState === "error");
      if (emailErr) return;

      try {
        this.centerDialogVisible = true;
        // 调用获取邮箱验证码接口
        await sendPasswordEmailCode({ email: this.form.email });
        this.$message.success("驗證碼已發送至郵箱 Verification code sent to email");
        // 开启倒计时
        this.startCodeCountDown();
      } catch (err) {
        this.$message.error(err.msg || "獲取驗證碼失敗 Failed to get code");
      } finally {
        this.centerDialogVisible = false;
      }
    },
    // 验证码倒计时逻辑
    startCodeCountDown() {
      this.codeDisabled = true;
      let count = this.codeCount;
      this.codeBtnText = `${count}s 後重發 Resend(${count}s)`;
      this.codeTimer = setInterval(() => {
        count--;
        this.codeBtnText = `${count}s 後重發 Resend(${count}s)`;
        if (count <= 0) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.codeDisabled = false;
          this.codeBtnText = "刷新驗證碼 Get Code";
        }
      }, 1000);
    },
    // 提交重置密码
    async onConfirm() {
      try {
        await this.$refs.form.validate();
        this.centerDialogVisible = true;
        await forgetPasswordEmail(this.form);
        this.$message.success(this.$t("other.forgetPasswordSuccess"));
        this.onBackText();
      } catch (err) {
        console.log("表單校驗失敗", err);
      } finally {
        this.centerDialogVisible = false;
      }
    },
    // 返回登录页
    onBackText() {
      // 返回时清除定时器
      if (this.codeTimer) clearInterval(this.codeTimer);
      this.$router.push({ path: "/login" });
    }
  },
};
</script>

<style lang="scss" scoped>
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.security-box {
  width: 43rem;
}
.security-title {
  color: #8e8e8e;
  font-weight: bold;
  line-height: 1.6rem;
  margin-bottom: 0.5rem;
}
// 验证码行内布局
.code-row {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  .el-input {
    flex: 1;
  }
}
.code-btn {
  white-space: nowrap;
  height: 2.75rem;
}
.security-button {
  margin: 1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  font-size: 1.125rem;
  color: #444444;
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .security-box {
    width: 27rem;
  }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain {
    height: 100%;
  }
  .security-box {
    width: 20rem;
    max-width: 90vw;
  }
  .code-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  .code-btn {
    width: 100%;
  }
}
::v-deep {
  .el-input__inner {
    border-radius: 0.625rem;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .el-input-group__prepend {
    border-top-left-radius: 3.125rem;
    border-bottom-left-radius: 3.125rem;
    background-color: #fffbed;
    border: 0.0625rem solid #fffbed;
    padding: 0 1.25rem;
    padding-right: 0;
  }
  .el-form-item__error {
    font-size: 14px;
    line-height: 1.6;
    padding-top: 0;
  }
  .el-input__icon {
    width: 1.75rem;
    line-height: 2.75rem;
  }
  .el-icon-circle-close {
    font-size: 1.75rem;
  }
  .el-icon-circle-check {
    color: #008000;
    font-size: 1.75rem;
  }
  .el-button + .el-button {
    margin: 0;
    margin-top: 1.125rem;
  }
  .security-button:nth-child(1) {
    background-color: #fcc03a;
  }
  .security-button:nth-last-child(1) {
    background-color: #ffffff;
  }
  .el-form-item {
    margin-bottom: 1.5rem;
  }
}
</style>